import './AdminLogin.scss';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useState } from 'react';

const AdminLogin = () => {
  const connection = process.env.REACT_APP_API_URL || '';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validateForm = () => {
    const newErrors = {};

    if (!email.trim()) {
      newErrors.email = 'Email is required';
    }

    if (!password.trim()) {
      newErrors.password = 'Password is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);
      setErrors({});

      const loginObj = {
        email: email.trim(),
        password: password
      };

      const response = await axios.post(`${connection}/admin/login`, loginObj);

      const { token, adminUser } = response.data;

      localStorage.setItem('tg_admin_token', token);
      localStorage.setItem('tg_admin_user', JSON.stringify(adminUser));

      setLoading(false);
      navigate('/admin/dashboard');
    } catch (err) {
      setLoading(false);

      if (err.response) {
        if (err.response.status === 401) {
          setErrors({
            general: 'Invalid email or password',
            password: 'Incorrect password or unauthorized login'
          });
        } else if (err.response.status === 403) {
          setErrors({
            general: err.response.data?.message || 'This admin account is inactive.'
          });
        } else if (err.response.status === 404) {
          setErrors({
            general: 'Admin login route was not found. Check your API URL and backend route mounting.'
          });
        } else {
          setErrors({
            general: err.response.data?.message || 'Unable to log in right now.'
          });
        }
      } else {
        setErrors({
          general: 'Unable to connect to the server.'
        });
      }

      console.error('Admin login error:', err);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <p className="admin-login-card__eyebrow">The Tour Golfers</p>
        <h1>Admin Login</h1>
        <p className="admin-login-card__subtitle">
          Sign in to review invite requests, contact submissions, and partnership inquiries.
        </p>

        <form className="admin-login-form" onSubmit={handleLogin}>
          <div className="admin-login-form__field">
            <label htmlFor="admin-email">Email</label>
            <input
              id="admin-email"
              type="email"
              placeholder="you@thetourgolfers.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="on"
              required
            />
            {errors.email ? <p className="admin-login-form__error">{errors.email}</p> : null}
          </div>

          <div className="admin-login-form__field">
            <label htmlFor="admin-password">Password</label>
            <input
              id="admin-password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="on"
              required
            />
            {errors.password ? <p className="admin-login-form__error">{errors.password}</p> : null}
          </div>

          {errors.general ? (
            <div className="admin-login-form__error admin-login-form__error--general">
              {errors.general}
            </div>
          ) : null}

          <button type="submit" disabled={loading}>
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;